import { AlertCircle, Check, Info } from 'lucide-react';
import { useStore } from '@/state/store';
import { cn } from '@/lib/utils';

const icons = {
  info: <Info size={14} />,
  error: <AlertCircle size={14} />,
  success: <Check size={14} />,
};

export function Toasts() {
  const toasts = useStore((s) => s.ui.toasts);
  const dismiss = useStore((s) => s.dismissToast);

  return (
    <div className="pointer-events-none fixed bottom-[calc(env(safe-area-inset-bottom)+72px)] left-1/2 z-[60] flex w-[calc(100%-24px)] max-w-[420px] -translate-x-1/2 flex-col items-center gap-2 sm:bottom-6 sm:w-auto">
      {toasts.map((t) => (
        <button
          key={t.id}
          onClick={() => dismiss(t.id)}
          className={cn(
            'pointer-events-auto flex max-w-full animate-pop items-center gap-2 rounded-full py-2 pl-3 pr-4',
            'bg-[var(--bg-elevated)] text-[12.5px] shadow-[var(--shadow-lg)] ring-1 ring-[var(--hairline)]',
            'backdrop-blur-xl',
            t.tone === 'error' && 'text-[var(--danger)]',
            t.tone === 'success' && 'text-[var(--accent)]',
          )}
        >
          {icons[t.tone]}
          <span className="truncate text-[var(--text-primary)]">{t.message}</span>
        </button>
      ))}
    </div>
  );
}
